import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { EquipmentProvider } from './contexts/EquipmentContext';
import Layout from './components/Layout';
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import EquipmentPage from './pages/equipment/EquipmentPage';
import RentalPage from './pages/rental/RentalPage';
import FeeDetailsPage from './pages/fee/FeeDetailsPage';
import AdminReviewPage from './pages/admin/AdminReviewPage';
import PersonnelManagementPage from './pages/admin/PersonnelManagementPage';
import AnnouncementManagePage from './pages/announcements/AnnouncementManagePage';
import ProfilePage from './pages/profile/ProfilePage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <EquipmentProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="equipment" element={<EquipmentPage />} />
            <Route path="rental" element={<RentalPage />} />
            <Route path="fee-details" element={<FeeDetailsPage />} />
            <Route path="team-rental" element={<Navigate to="/dashboard" replace />} />
            <Route path="admin-review" element={<AdminReviewPage />} />
            <Route path="personnel-management" element={<PersonnelManagementPage />} />
            <Route path="announcements-manage" element={<AnnouncementManagePage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
        </Routes>
      </EquipmentProvider>
    </AuthProvider>
  );
}

export default App;
